import Vue from 'vue'
import Vuex from 'vuex'

import COVER from '@/utils/COVER'
import COVERAPP from '@/utils/COVERAPP'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    aid: '5de89faf59faab0028528180',
    isApp: false,
    userinfo: {},
    bdlist: [
      {
        id: '5de89ff9d31b14002e271221',
        title: '年度图书榜'
      },
      {
        id: '5de8a009d31b14002e271224',
        title: '年度诗集榜'
      },
      {
        id: '5de8a012471dd3001eccce44',
        title: '年度非虚构榜'
      },
      {
        id: '5de8a01a59faab0028528195',
        title: '年度电影榜'
      },
      {
        id: '5de8a023187bd30042471678',
        title: '年度电视榜'
      },
      {
        id: '5de8a02b187bd3004247167b',
        title: '年度音乐榜'
      },
      {
        id: '5de8a034d31b14002e27122e',
        title: '年度文旅大事件榜'
      }
    ]
  },
  mutations: {
    appFlag(state, flag) {
			state.isApp = flag
    },
    getUserinfo(state, data) {
      state.userinfo = data
    }
  },
  actions: {
    appFlagAsync ({ commit, state }, flag) {
			commit('appFlag', flag)
    },
    getUserinfoAsync ({ commit, state }) {
      let sessionuserinfo = sessionStorage.getItem('COVER_USERINFO')
      if(sessionuserinfo) {
        commit('getUserinfo', JSON.parse(sessionuserinfo))
        return
      }
      if(COVERAPP.Attribute.isApp()) {
          COVERAPP.Method.GetUser({
              callback(res) {
                  let userinfo = JSON.parse(res);
                  if(!COVER.isEmpty(userinfo.user_id)){
                      let info = COVER.resetUserData(userinfo)
                      sessionStorage.setItem('COVER_USERINFO', JSON.stringify(info))
                      commit('getUserinfo', info)
                  }
              }
          })
      } else {
          COVER.getUser((res) => {
              commit('getUserinfo', JSON.parse(JSON.stringify(res)))
          })
      }      
    }
  },
  modules: {
  }
})
